/**
 * The single canonical Schema.org graph for the ToxicDetector homepage.
 *
 * ONE graph, ONE place. Do not emit a second Organization / WebSite /
 * WebApplication block from any other homepage component — duplicate entities
 * confuse Google's entity resolution.
 *
 * Every claim below is visible on the homepage itself. No ratings, no reviews,
 * no awards, no user counts, no accuracy percentages — nothing fabricated.
 */
export const HOME_TITLE =
  'ToxicDetector – AI Conversation Analyzer for Gaslighting, Manipulation & Toxic Relationships'
export const HOME_DESCRIPTION =
  'ToxicDetector is an AI conversation analyzer that reviews your chats and screenshots for potentially toxic communication patterns, gaslighting and manipulation signals — and returns a private forensic report.'
export const HOME_KEYWORDS =
  'AI conversation analysis, toxic text message analysis, gaslighting detection, manipulation detection, screenshot conversation analysis, WhatsApp chat toxicity analysis, forensic chat analysis, relationship red flags, AI forensic reports'
const LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/65popPutPXjwqKGt3qtuH1/flag.jpg'
export const HOME_SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://toxicdetector.com/#organization',
      name: 'ToxicDetector AI',
      legalName: 'ToxicDetector AI & Forensic Systems LTD',
      url: 'https://toxicdetector.com/',
      logo: {
        '@type': 'ImageObject',
        url: LOGO_URL,
      },
      founder: {
        '@type': 'Person',
        name: 'Chukwuka Paulgreen Agodi',
        jobTitle: 'Founder & Chief Architect',
        url: 'https://toxicdetector.com/founder',
        sameAs: ['https://www.linkedin.com/in/chukwuka-paulgreen-b64334385/'],
      },
      sameAs: ['https://www.trustpilot.com/review/toxicdetector.com'],
    },
    {
      '@type': 'WebSite',
      '@id': 'https://toxicdetector.com/#website',
      url: 'https://toxicdetector.com/',
      name: 'ToxicDetector AI',
      description: HOME_DESCRIPTION,
      inLanguage: 'en',
      publisher: {
        '@id': 'https://toxicdetector.com/#organization',
      },
    },
    {
      '@type': 'WebApplication',
      '@id': 'https://toxicdetector.com/#webapp',
      name: 'ToxicDetector AI',
      url: 'https://toxicdetector.com/',
      applicationCategory: 'HealthApplication',
      operatingSystem: 'Web',
      description:
        'AI-powered conversation analysis that helps identify potentially toxic communication patterns, manipulation, gaslighting, and other behavioral signals in text conversations.',
      publisher: {
        '@id': 'https://toxicdetector.com/#organization',
      },
      featureList: [
        'AI conversation analysis',
        'Toxic communication pattern detection',
        'Gaslighting pattern analysis',
        'Manipulation pattern detection',
        'Screenshot and WhatsApp chat analysis',
        'Conversation risk analysis',
        'AI forensic reports',
      ],
    },
  ],
}
